// extracted by mini-css-extract-plugin
export default {"container":"UserProfile_container__xnzkW","userContainer":"UserProfile_userContainer__u6LIU"};